export default {
  BASE: 'shuffle',
  SHUFFLE_ITEM: 'shuffle-item',
  VISIBLE: 'shuffle-item--visible',
  HIDDEN: 'shuffle-item--hidden',
};



/** WEBPACK FOOTER **
 ** ./src/classes.js
 **/